import { faCog } from '@fortawesome/pro-regular-svg-icons';

import affectationsDpDept from './affectations-dp-dept';
import centrale from './centrale';
import clients from './clients';
import delegues from './delegues';
import documents from './documents';
import emails from './emails';
import entites from './entites';
import factures from './factures';
import fiscalite_zones from './fiscalite_zones';
import individus from './individus';
import lots from './lots';
import mandats from './mandats';
import notaires from './notaires';
import passerelles from './passerelles';
import promoteurs from './promoteurs';
import ventes from './ventes';
import villes from './villes';

// Raw list of all resources
const list = [
  centrale,
  promoteurs,
  lots,
  ventes,
  factures,
  notaires,
  mandats,
  individus,
  documents,
  entites,
  clients,
  delegues,
  emails,
  passerelles,
  villes,
  affectationsDpDept,
  fiscalite_zones,
];

// List of resources formatted for the navbar
export const listForNavBar = [
  centrale,
  promoteurs,
  lots,
  ventes,
  factures,
  notaires,
  mandats,
  individus,
  documents,
  entites,
  clients,
  delegues,
  emails,
  passerelles,
  villes,
  {
    title: 'Paramétrages',
    icon: faCog,
    children: [affectationsDpDept, fiscalite_zones],
  },
];

export default list;
